import * as React from 'react'
import styled from 'styled-components'
import Checkmark from './Checkmark'

interface CheckboxProps {
  value?: boolean
  children?: any
  onCheck: (check) => void
}

export const FormCheckbox = (props: CheckboxProps) => {
  const { value, children, onCheck } = props

  return (
    <Label>
      <Box value={value} onChange={(e) => onCheck(e.target.checked)} />
      <Mark checked={!!value} size={20} />
      <span>{children}</span>
    </Label>
  )
}

const Label = styled.label`
  display: block;
  position: relative;
  margin-bottom: 12px;
  padding-left: 50px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    opacity: 0;
  }
`

const Box = styled.input.attrs((props) => ({
  type: 'checkbox',
  checked: props.checked
}))`
  background: red;
`

const Mark = styled(Checkmark)`
  top: 5px;
  bottom: unset;
  left: 0;
`



// WEBPACK FOOTER //
// ./src/components/atoms/input/FormCheckbox.tsx